import { render, staticRenderFns } from "./ViewTiers.vue?vue&type=template&id=28d6d226&scoped=true&"
import script from "./ViewTiers.vue?vue&type=script&lang=ts&"
export * from "./ViewTiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d6d226",
  null
  
)

export default component.exports